var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-100" },
    [
      !_vm.isEmptyData
        ? _c("v-client-table", {
            ref: "disclaimerTable",
            staticClass:
              "w-100 vue-custom-table no-pagination disclaimers-table",
            attrs: {
              id: "disclaimers-table-id",
              data: _vm.disclaimers,
              columns: _vm.columns,
              options: _vm.options,
              name: "disclaimersTable",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "h__mandatory",
                  fn: function () {
                    return [
                      _c(
                        "span",
                        { staticClass: "d-flex flex-row align-items-center" },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("global.words.mandatory") + "?") +
                              "\n        "
                          ),
                          _c("icon", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip",
                                value: {
                                  title: _vm.$t(
                                    "settings.disclaimers.mandatoryMessage"
                                  ),
                                },
                                expression:
                                  "{\n            title: $t('settings.disclaimers.mandatoryMessage')\n          }",
                              },
                            ],
                            staticClass: "ml-1 clickable text-primary",
                            attrs: { name: "info-circle" },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "enabled",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("div", { staticClass: "form-group-checkbox" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "pretty p-icon p-jelly p-smooth p-curve mr-0",
                          },
                          [
                            _c("input", {
                              staticClass: "checkbox",
                              attrs: {
                                id: "disclaimers-enabled-" + row.id,
                                type: "checkbox",
                              },
                              domProps: { checked: row.enabled },
                              on: {
                                change: function ($event) {
                                  return _vm.toggleDisclaimerProperty(
                                    row,
                                    "enabled"
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "state p-success" }, [
                              _c("i", { staticClass: "icon fa fa-check" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  attrs: {
                                    for: "disclaimers-enabled-" + row.id,
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { display: "none" } },
                                    [_vm._v("Success")]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "message",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("pre", { staticClass: "my-2" }, [
                        _vm._v(
                          "        " + _vm._s(row.description) + "\n      "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "document",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "a",
                        {
                          staticClass: "text-primary clickable",
                          on: {
                            click: function ($event) {
                              return _vm.showPreviewer(row)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n        " + _vm._s(row.fileName) + "\n      "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "mandatory",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("div", { staticClass: "form-group-checkbox" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "pretty p-icon p-jelly p-smooth p-curve mr-0",
                          },
                          [
                            _c("input", {
                              staticClass: "checkbox",
                              attrs: {
                                id: "disclaimers-mandatory-" + row.id,
                                type: "checkbox",
                              },
                              domProps: { checked: row.mandatory },
                              on: {
                                change: function ($event) {
                                  return _vm.toggleDisclaimerProperty(
                                    row,
                                    "mandatory"
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "state p-success" }, [
                              _c("i", { staticClass: "icon fa fa-check" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  attrs: {
                                    for: "disclaimers-mandatory-" + row.id,
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { display: "none" } },
                                    [_vm._v("Success")]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "actions",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center" },
                        [
                          _c(
                            "a",
                            {
                              staticClass:
                                "btn request-from-type clickable text-primary bold text-capitalize",
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("edit-disclaimer", row)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("global.words.edit")) +
                                  "\n        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.disclaimers.length > 1 ||
                          _vm.defaultDisclaimerEnabled
                            ? _c("inline-prompt", {
                                ref: "prompt",
                                staticClass:
                                  "d-inline-block bold text-gray ml-2",
                                attrs: {
                                  placement: "left",
                                  "action-type": "delete",
                                  "confirmation-text": _vm.$t(
                                    "global.messages.deleteConfirmation",
                                    {
                                      item: _vm.$t(
                                        "settings.disclaimers.disclaimer"
                                      ),
                                    }
                                  ),
                                },
                                on: {
                                  accept: function ($event) {
                                    return _vm.handleRemove(row)
                                  },
                                },
                              })
                            : _c("icon", {
                                attrs: {
                                  name: "trash",
                                  "icon-class": "text-danger clickable",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.showDeleteDisclaimerModal(row)
                                  },
                                },
                              }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              1802323498
            ),
          })
        : _c(
            "div",
            { staticClass: "d-flex flex-column align-items-center w-100" },
            [
              _c(
                "no-results",
                {
                  attrs: {
                    "img-src": require("@Shared/@Assets/img/application-missing.png"),
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t("settings.disclaimers.thereAreNoDisclaimers")
                      ) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          ),
      _vm._v(" "),
      _c("delete-disclaimer-modal", {
        ref: "deleteDisclaimerModal",
        on: { "confirm-enable-default": _vm.handleDeleteConfirmation },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }